import { createContext as e, memo as t, useCallback as n, useContext as r, useEffect as i, useMemo as a, useRef as o, useState as s } from "react";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import { I18nextProvider as u, initReactI18next as d, useTranslation as f } from "react-i18next";
import { MAX_SCREEN_NAME_LENGTH as p, WsEnvelopeValidationError as m, parseWsEnvelopeJson as h, serializeWsEnvelope as g } from "@a-conversa/shared-types";
import _ from "i18next";
import v from "i18next-icu";
import { buildInitOptions as y } from "@a-conversa/i18n-catalogs";
import { create as b } from "zustand";
//#region src/auth/AuthContext.ts
var x = e(void 0), S = "<pending>";
function ee(e) {
	if (typeof e != "object" || !e) return !1;
	let t = e;
	return typeof t.userId == "string" && typeof t.screenName == "string";
}
function C(e) {
	if (ee(e)) return {
		userId: e.userId,
		screenName: e.screenName
	};
}
function w(e) {
	let [t, r] = s("loading"), [a, o] = s(void 0), [l, u] = s(void 0), d = n(async () => {
		u(void 0);
		try {
			let e = await fetch("/api/auth/me", {
				method: "GET",
				credentials: "include",
				headers: { Accept: "application/json" }
			});
			if (e.status === 401) {
				o(void 0), r("unauthenticated");
				return;
			}
			if (!e.ok) {
				o(void 0), r("unauthenticated"), u({
					code: "auth-me-failed",
					message: `unexpected status ${String(e.status)} from /api/auth/me`
				});
				return;
			}
			let t = C(await e.json());
			if (t === void 0) {
				o(void 0), r("unauthenticated"), u({
					code: "auth-me-malformed",
					message: "/api/auth/me returned an unexpected body shape"
				});
				return;
			}
			if (t.screenName === S) {
				o(t), r("needs-screen-name");
				return;
			}
			o(t), r("authenticated");
		} catch (e) {
			o(void 0), r("unauthenticated"), u({
				code: "network-error",
				message: e instanceof Error ? e.message : String(e)
			});
		}
	}, []), f = n(async () => {
		u(void 0);
		try {
			await fetch("/api/auth/logout", {
				method: "POST",
				credentials: "include"
			});
		} catch (e) {
			u({
				code: "logout-network-error",
				message: e instanceof Error ? e.message : String(e)
			});
		}
		typeof window < "u" && window.location.reload();
	}, []);
	i(() => {
		d();
	}, [d]);
	let p = {
		status: t,
		user: a,
		error: l,
		refresh: d,
		logout: f
	};
	return /* @__PURE__ */ c(x.Provider, {
		value: p,
		children: e.children
	});
}
//#endregion
//#region src/auth/AuthValueProvider.tsx
function te(e) {
	let { value: t, children: n } = e;
	return /* @__PURE__ */ c(x.Provider, {
		value: t,
		children: n
	});
}
//#endregion
//#region src/auth/useAuth.ts
function T() {
	let e = r(x);
	if (e === void 0) throw Error("useAuth must be called inside <AuthProvider>");
	return e;
}
//#endregion
//#region src/error-mapper/mapScreenNameError.ts
var ne = Object.freeze({
	"screen-name-invalid": "auth.screenName.errors.invalidCharacter",
	"screen-name-already-set": "auth.screenName.errors.alreadySet",
	"auth-pending-cookie-invalid": "auth.screenName.errors.pendingCookieInvalid",
	"validation-failed": "auth.screenName.errors.empty"
}), E = "auth.screenName.errors.generic";
function D(e) {
	return ne[e] ?? E;
}
//#endregion
//#region src/screen-name/ScreenNameForm.tsx
var O = 256, k = new Set([
	8234,
	8235,
	8236,
	8237,
	8238,
	8294,
	8295,
	8296,
	8297,
	8203,
	8204,
	8205,
	8206,
	8207,
	8288,
	65279
]), A = /[ --]/u, j = /^[\p{L}\p{N}\p{P}\p{S}\p{Zs}]+$/u;
function M(e) {
	if (e.length === 0) return {
		ok: !1,
		reason: "empty"
	};
	let t = e.trim();
	if (t.length === 0) return {
		ok: !1,
		reason: "whitespace-only"
	};
	let n = t.normalize("NFKC").trim();
	if (n.length === 0) return {
		ok: !1,
		reason: "whitespace-only"
	};
	if (n.length > p) return {
		ok: !1,
		reason: "too-long"
	};
	if (A.test(n)) return {
		ok: !1,
		reason: "invalid-character"
	};
	for (let e of n) {
		let t = e.codePointAt(0);
		if (t !== void 0 && k.has(t)) return {
			ok: !1,
			reason: "invalid-character"
		};
	}
	return j.test(n) ? {
		ok: !0,
		value: n
	} : {
		ok: !1,
		reason: "invalid-character"
	};
}
function re(e) {
	switch (e) {
		case "empty": return "auth.screenName.errors.empty";
		case "whitespace-only": return "auth.screenName.errors.whitespaceOnly";
		case "too-long": return "auth.screenName.errors.tooLong";
		case "invalid-character": return "auth.screenName.errors.invalidCharacter";
	}
}
function ie(e) {
	let { t } = f(), n = T(), [r, a] = s(""), [u, d] = s(!1), [m, h] = s(void 0), g = o(null);
	i(() => {
		g.current?.focus();
	}, []);
	let _ = r.trim(), v = u || _.length === 0;
	async function y() {
		h(void 0);
		let t = M(r);
		if (!t.ok) {
			h(re(t.reason));
			return;
		}
		d(!0);
		try {
			let r = await fetch("/api/auth/screen-name", {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json"
				},
				body: JSON.stringify({ screenName: t.value })
			});
			if (r.ok) {
				await n.refresh(), e.onSuccess();
				return;
			}
			let i = "unknown";
			try {
				let e = await r.json();
				typeof e == "object" && e && "error" in e && typeof e.error == "object" && e.error !== null && typeof e.error.code == "string" && (i = e.error.code);
			} catch {}
			h(D(i)), g.current?.focus();
		} catch {
			h("auth.screenName.errors.generic"), g.current?.focus();
		} finally {
			d(!1);
		}
	}
	let b = m !== void 0;
	return /* @__PURE__ */ l("form", {
		"data-testid": "screen-name-form",
		onSubmit: (e) => {
			e.preventDefault(), y();
		},
		children: [
			/* @__PURE__ */ c("label", {
				htmlFor: "screen-name-input",
				"data-testid": "screen-name-label",
				children: t("auth.screenName.label")
			}),
			/* @__PURE__ */ c("input", {
				ref: g,
				id: "screen-name-input",
				"data-testid": "screen-name-input",
				type: "text",
				value: r,
				maxLength: O,
				autoComplete: "off",
				inputMode: "text",
				"aria-invalid": b,
				"aria-describedby": "screen-name-helper screen-name-error",
				onChange: (e) => {
					a(e.target.value), m !== void 0 && h(void 0);
				}
			}),
			/* @__PURE__ */ c("p", {
				id: "screen-name-helper",
				"data-testid": "screen-name-helper",
				children: t("auth.screenName.helper", {
					used: _.length,
					max: p
				})
			}),
			b && /* @__PURE__ */ c("p", {
				id: "screen-name-error",
				"data-testid": "screen-name-error",
				role: "alert",
				"aria-live": "polite",
				"aria-atomic": "true",
				children: t(m)
			}),
			/* @__PURE__ */ c("button", {
				type: "submit",
				"data-testid": "screen-name-submit",
				disabled: v,
				children: t("auth.screenName.submit")
			})
		]
	});
}
//#endregion
//#region src/slots/slots.ts
var N = [
	"moderator",
	"debater-A",
	"debater-B"
];
function ae(e) {
	let t = {};
	for (let n of e) {
		if (n.kind === "participant-joined") {
			t[n.payload.role] = {
				userId: n.payload.user_id,
				screenName: n.payload.screen_name
			};
			continue;
		}
		if (n.kind === "participant-left") for (let e of N) t[e]?.userId === n.payload.user_id && delete t[e];
	}
	return t;
}
function oe(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	for (let e of n) e.kind === "participant-joined" ? r.set(e.payload.user_id, "joined") : e.kind === "participant-left" && r.set(e.payload.user_id, "left");
	let i = {};
	for (let t of e) r.get(t.userId) !== "left" && (i[t.role] = {
		userId: t.userId,
		screenName: t.screenName
	});
	for (let e of N) {
		let n = t[e];
		n !== void 0 && (i[e] = n);
	}
	return i;
}
//#endregion
//#region src/login-logout/LoginButton.tsx
function se(e) {
	let { className: t, "data-testid": n = "auth-login-button" } = e, { t: r } = f();
	return /* @__PURE__ */ c("a", {
		href: "/api/auth/login",
		"data-testid": n,
		role: "button",
		className: t,
		children: r("auth.login.button")
	});
}
//#endregion
//#region src/login-logout/logout.ts
async function ce() {
	try {
		await fetch("/api/auth/logout", {
			method: "POST",
			credentials: "include"
		});
	} catch {}
	typeof window < "u" && window.location.reload();
}
//#endregion
//#region src/i18n/createI18nInstance.ts
async function le(e) {
	return await _.use(v).use(d).init(y(e)), _;
}
//#endregion
//#region src/i18n/I18nProvider.tsx
function ue(e) {
	let { i18n: t, children: n } = e;
	return /* @__PURE__ */ c(u, {
		i18n: t,
		children: n
	});
}
//#endregion
//#region src/diagnostics/diagnostic-highlights.ts
var P = Object.freeze({
	nodes: /* @__PURE__ */ new Map(),
	edges: /* @__PURE__ */ new Map()
});
function F(e) {
	throw Error(`diagnostic-highlights: unrouted wire kind ${JSON.stringify(e)}`);
}
function I(e) {
	let t = e.diagnostic;
	switch (t.kind) {
		case "cycle": return `cycle\0${[...t.nodes].sort().join("\0")}`;
		case "contradiction": return `contradiction\0${t.nodeA}\0${t.nodeB}`;
		case "multi-warrant": {
			let e = [...t.warrantNodeIds].sort();
			return `multi-warrant\0${t.dataNodeId}\0${t.claimNodeId}\0${e.join("\0")}`;
		}
		case "dangling-claim": return `dangling-claim\0${t.nodeId}`;
		case "coherency-hint": return de(t.hint);
		default: return F(t);
	}
}
function de(e) {
	switch (e.kind) {
		case "incomplete-warrant-missing-bridges-to": return `coherency-hint\0incomplete-warrant-missing-bridges-to\0${e.warrantNodeId}\0${e.dataNodeId}`;
		case "incomplete-warrant-missing-bridges-from": return `coherency-hint\0incomplete-warrant-missing-bridges-from\0${e.warrantNodeId}\0${e.claimNodeId}`;
		case "self-contradicts": return `coherency-hint\0self-contradicts\0${e.edgeId}`;
		case "annotation-of-annotation-chain": return `coherency-hint\0annotation-of-annotation-chain\0${e.edgeId}`;
		case "self-referential-annotation-contradicts": return `coherency-hint\0self-referential-annotation-contradicts\0${e.edgeId}`;
		case "non-self-referential-annotation-contradicts": return `coherency-hint\0non-self-referential-annotation-contradicts\0${e.edgeId}`;
		default: return F(e);
	}
}
function L(e) {
	let t = e.diagnostic;
	switch (t.kind) {
		case "cycle": return {
			nodes: t.nodes,
			edges: []
		};
		case "contradiction": return {
			nodes: [t.nodeA, t.nodeB],
			edges: t.edges
		};
		case "multi-warrant": return {
			nodes: [
				t.dataNodeId,
				t.claimNodeId,
				...t.warrantNodeIds
			],
			edges: []
		};
		case "dangling-claim": return {
			nodes: [t.nodeId],
			edges: []
		};
		case "coherency-hint": return fe(t.hint);
		default: return F(t);
	}
}
function fe(e) {
	switch (e.kind) {
		case "incomplete-warrant-missing-bridges-to": return {
			nodes: [e.warrantNodeId, e.dataNodeId],
			edges: []
		};
		case "incomplete-warrant-missing-bridges-from": return {
			nodes: [e.warrantNodeId, e.claimNodeId],
			edges: []
		};
		case "self-contradicts": return {
			nodes: [e.nodeId],
			edges: [e.edgeId]
		};
		case "annotation-of-annotation-chain": return {
			nodes: [e.sourceAnnotationId, e.targetAnnotationId],
			edges: [e.edgeId, e.incomingEdgeId]
		};
		case "self-referential-annotation-contradicts": return {
			nodes: [e.nodeId, e.annotationId],
			edges: [e.edgeId]
		};
		case "non-self-referential-annotation-contradicts": return {
			nodes: [
				e.nodeId,
				e.annotationId,
				e.anchorNodeId
			],
			edges: [e.edgeId]
		};
		default: return F(e);
	}
}
function pe(e) {
	if (e.size === 0) return P;
	let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
	function r(e, t, n, r) {
		let i = e.get(t);
		i === void 0 ? (i = {
			severity: n,
			kinds: [],
			seen: /* @__PURE__ */ new Set()
		}, e.set(t, i)) : n === "blocking" && i.severity === "advisory" && (i.severity = "blocking"), i.seen.has(r) || (i.seen.add(r), i.kinds.push(r));
	}
	for (let i of e.values()) {
		let e = L(i);
		for (let n of e.nodes) r(t, n, i.severity, i.kind);
		for (let t of e.edges) r(n, t, i.severity, i.kind);
	}
	let i = /* @__PURE__ */ new Map();
	for (let [e, n] of t) i.set(e, {
		severity: n.severity,
		kinds: n.kinds
	});
	let a = /* @__PURE__ */ new Map();
	for (let [e, t] of n) a.set(e, {
		severity: t.severity,
		kinds: t.kinds
	});
	return {
		nodes: i,
		edges: a
	};
}
function me(e, t) {
	return e.nodes.has(t);
}
function he(e, t) {
	return e.edges.has(t);
}
function ge(e, t, n) {
	return (t === "node" ? e.nodes : e.edges).get(n)?.severity ?? "none";
}
function _e(e) {
	let t = [];
	for (let [n, r] of e) {
		let { nodes: e } = L(r);
		for (let i of e) t.push({
			identityKey: n,
			nodeId: i,
			severity: r.severity
		});
	}
	return t;
}
function ve(e) {
	let t = [];
	for (let [n, r] of e) {
		let { edges: e } = L(r);
		for (let i of e) t.push({
			identityKey: n,
			edgeId: i,
			severity: r.severity
		});
	}
	return t;
}
//#endregion
//#region src/ws/defaultStore.ts
var ye = new Set([
	"proposed",
	"agreed",
	"disputed",
	"committed",
	"withdrawn",
	"meta-disagreement",
	"awaiting-proposal"
]);
function be(e) {
	return ye.has(e);
}
function xe() {
	return {
		lastAppliedSequence: 0,
		events: [],
		pendingProposalFacetStatus: /* @__PURE__ */ new Map(),
		activeDiagnostics: /* @__PURE__ */ new Map(),
		borrowedNodeContent: /* @__PURE__ */ new Map(),
		borrowedEdgeContent: /* @__PURE__ */ new Map(),
		borrowedAnnotationContent: /* @__PURE__ */ new Map()
	};
}
function Se(e, t, n) {
	return `${e}:${t}:${n}`;
}
function R(e, t) {
	return e.sessionState[t] || xe();
}
function z() {
	return (e) => ({
		connectionStatus: "idle",
		connectionId: void 0,
		subscriptions: /* @__PURE__ */ new Set(),
		sessionState: {},
		lastError: void 0,
		setConnectionStatus: (t) => e({ connectionStatus: t }),
		setConnectionId: (t) => e({ connectionId: t }),
		trackSubscription: (t) => {
			let n = !1;
			return e((e) => {
				if (e.subscriptions.has(t)) return e;
				let r = new Set(e.subscriptions);
				return r.add(t), n = !0, { subscriptions: r };
			}), n;
		},
		untrackSubscription: (t) => e((e) => {
			if (!e.subscriptions.has(t)) return e;
			let n = new Set(e.subscriptions);
			return n.delete(t), { subscriptions: n };
		}),
		applyEvent: (t, n) => {
			let r = !1;
			return e((e) => {
				let i = R(e, t.sessionId);
				if (t.sequence <= i.lastAppliedSequence) return e;
				let a = i.pendingProposalFacetStatus, o = a;
				if (t.kind === "entity-removed") {
					let e = t.payload, n = e.entity_kind, r = e.entity_id;
					if (n !== void 0 && r !== void 0) {
						let e = `${n}:${r}:`, t = null;
						for (let n of a.keys()) n.startsWith(e) && (t === null && (t = new Map(a)), t.delete(n));
						t !== null && (o = t);
					}
				}
				let s = i.borrowedNodeContent, c = i.borrowedEdgeContent, l = i.borrowedAnnotationContent;
				if (n !== void 0) {
					let e = n.nodes;
					if (e !== void 0 && e.length > 0) {
						let t = new Map(i.borrowedNodeContent);
						for (let n of e) t.set(n.id, n);
						s = t;
					}
					let t = n.edges;
					if (t !== void 0 && t.length > 0) {
						let e = new Map(i.borrowedEdgeContent);
						for (let n of t) e.set(n.id, n);
						c = e;
					}
					let r = n.annotations;
					if (r !== void 0 && r.length > 0) {
						let e = new Map(i.borrowedAnnotationContent);
						for (let t of r) e.set(t.id, t);
						l = e;
					}
				}
				let u = {
					...i,
					lastAppliedSequence: t.sequence,
					events: [...i.events, t],
					pendingProposalFacetStatus: o,
					borrowedNodeContent: s,
					borrowedEdgeContent: c,
					borrowedAnnotationContent: l
				};
				return r = !0, { sessionState: {
					...e.sessionState,
					[t.sessionId]: u
				} };
			}), r;
		},
		applySnapshot: (t, n) => e((e) => {
			let r = R(e, t);
			if (n < r.lastAppliedSequence) return e;
			let i = {
				...r,
				lastAppliedSequence: n
			};
			return { sessionState: {
				...e.sessionState,
				[t]: i
			} };
		}),
		applyProposalStatus: (t) => e((e) => {
			let n = R(e, t.sessionId), r = n.pendingProposalFacetStatus, i = r;
			if (t.entityKind !== void 0 && t.entityId !== void 0) {
				let e = t.entityKind, n = t.entityId, a = null;
				for (let [i, o] of Object.entries(t.perFacetStatus)) be(o) && (a === null && (a = new Map(r)), a.set(Se(e, n, i), o));
				a !== null && (i = a);
			}
			let a = {
				...n,
				pendingProposalFacetStatus: i
			};
			return { sessionState: {
				...e.sessionState,
				[t.sessionId]: a
			} };
		}),
		clearProposalFacetStatusForEntity: (t, n, r) => e((e) => {
			let i = e.sessionState[t];
			if (i === void 0) return e;
			let a = i.pendingProposalFacetStatus, o = `${n}:${r}:`, s = null;
			for (let e of a.keys()) e.startsWith(o) && (s === null && (s = new Map(a)), s.delete(e));
			if (s === null) return e;
			let c = {
				...i,
				pendingProposalFacetStatus: s
			};
			return { sessionState: {
				...e.sessionState,
				[t]: c
			} };
		}),
		applyDiagnostic: (t) => e((e) => {
			let n = R(e, t.sessionId), r = I(t), i = new Map(n.activeDiagnostics);
			t.status === "fired" ? i.set(r, t) : i.delete(r);
			let a = {
				...n,
				lastDiagnostic: t,
				activeDiagnostics: i
			};
			return { sessionState: {
				...e.sessionState,
				[t.sessionId]: a
			} };
		}),
		recordError: (t) => e({ lastError: t }),
		reset: () => e({
			connectionStatus: "idle",
			connectionId: void 0,
			subscriptions: /* @__PURE__ */ new Set(),
			sessionState: {},
			lastError: void 0
		})
	});
}
function B() {
	return b()(z());
}
//#endregion
//#region src/ws/client.ts
var V = class extends Error {
	name = "WsRequestError";
	code;
	details;
	constructor(e) {
		super(e.message), this.code = e.code, this.details = e.details;
	}
}, H = class extends Error {
	name = "WsRequestTimeoutError";
	type;
	id;
	constructor(e, t) {
		super(`ws request ${e}:${t} timed out`), this.type = e, this.id = t;
	}
}, Ce = "/api/ws", we = 1e4, Te = 250, Ee = 3e4, U = 1;
function De() {
	if (typeof crypto < "u" && typeof crypto.randomUUID == "function") return crypto.randomUUID();
	let e = (e) => e.toString(16).padStart(2, "0"), t = new Uint8Array(16);
	for (let e = 0; e < 16; e += 1) t[e] = Math.floor(Math.random() * 256);
	t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128;
	let n = Array.from(t, e);
	return `${n[0]}${n[1]}${n[2]}${n[3]}-${n[4]}${n[5]}-${n[6]}${n[7]}-${n[8]}${n[9]}-${n[10]}${n[11]}${n[12]}${n[13]}${n[14]}${n[15]}`;
}
function Oe(e) {
	return new WebSocket(e);
}
function W(e = {}) {
	let { url: t = Ce, makeSocket: n = Oe, randomId: r = De, defaultTimeoutMs: i = we, initialBackoffMs: a = Te, maxBackoffMs: o = Ee, autoReconnect: s = !0, onEnvelope: c, onStatusChange: l, scheduleTimeout: u = (e, t) => setTimeout(e, t), cancelTimeout: d = (e) => clearTimeout(e), store: f = B() } = e, p, _ = "idle", v = 0, y, b = !1, x = /* @__PURE__ */ new Map(), S = /* @__PURE__ */ new Set();
	c && S.add(c);
	function ee(e) {
		let t = f.getState();
		switch (e.type) {
			case "hello":
				t.setConnectionId(e.payload.connectionId);
				return;
			case "event-applied":
				t.applyEvent(e.payload.event, e.payload.borrowedEntities);
				return;
			case "snapshot-state":
				t.applySnapshot(e.payload.sessionId, e.payload.sequence);
				return;
			case "proposal-status":
				t.applyProposalStatus(e.payload);
				return;
			case "diagnostic":
				t.applyDiagnostic(e.payload);
				return;
			case "error":
				e.inResponseTo === void 0 && t.recordError(e.payload);
				return;
			default: return;
		}
	}
	function C(e) {
		_ !== e && (_ = e, f.getState().setConnectionStatus(e), l?.(e));
	}
	function w(e) {
		e.type === "hello" && (v = 0), ee(e);
		for (let t of S) try {
			t(e);
		} catch (e) {
			console.warn("ws: onEnvelope handler threw", e);
		}
		e.type === "hello" && k();
	}
	function te(e) {
		let t = e.inResponseTo;
		if (t === void 0) return !1;
		let n = x.get(t);
		return n === void 0 ? !1 : (d(n.timeoutHandle), x.delete(t), e.type === "error" ? n.reject(new V(e.payload)) : n.resolve(e), !0);
	}
	function T(e) {
		for (let t of x.values()) d(t.timeoutHandle), t.reject(e);
		x.clear();
	}
	function ne() {
		let e = a * 2 ** v;
		return Math.min(e, o);
	}
	function E() {
		if (!s || b) return;
		let e = ne();
		v += 1, C("reconnecting"), y = u(() => {
			y = void 0, j();
		}, e);
	}
	function D() {
		y !== void 0 && (d(y), y = void 0);
	}
	function O(e) {
		let t;
		try {
			t = h(e);
		} catch (e) {
			if (e instanceof m) {
				console.warn("ws: dropping malformed inbound frame", e.message);
				return;
			}
			throw e;
		}
		te(t), w(t);
	}
	function k() {
		let e = f.getState();
		for (let t of e.subscriptions) {
			let n = e.sessionState[t]?.lastAppliedSequence ?? 0;
			M("subscribe", { sessionId: t }).then(() => M("catch-up", {
				sessionId: t,
				sinceSequence: n
			}), (e) => {
				console.warn("ws: subscribe-resume failed", t, e);
			});
		}
	}
	function A(e) {
		p = e, e.onopen = () => {
			C("open");
		}, e.onclose = () => {
			if (p = void 0, T(/* @__PURE__ */ Error("ws connection closed")), b) {
				C("closed");
				return;
			}
			E();
		}, e.onerror = () => {}, e.onmessage = (e) => {
			let t = e.data;
			typeof t == "string" && O(t);
		};
	}
	function j() {
		b || (C(_ === "reconnecting" ? "reconnecting" : "connecting"), A(n(t)));
	}
	let M = (e, t, n = {}) => new Promise((a, o) => {
		if (n.signal?.aborted) {
			o(/* @__PURE__ */ Error("aborted"));
			return;
		}
		if (p === void 0 || p.readyState !== U) {
			o(/* @__PURE__ */ Error(`cannot send ${e}: socket not open (status=${_})`));
			return;
		}
		let s = r(), c = {
			type: e,
			id: s,
			payload: t
		}, l;
		try {
			l = g(c);
		} catch (e) {
			o(e instanceof Error ? e : Error(String(e)));
			return;
		}
		let f = u(() => {
			x.delete(s) && o(new H(e, s));
		}, n.timeoutMs ?? i), m = {
			type: e,
			resolve: a,
			reject: o,
			timeoutHandle: f
		};
		x.set(s, m), n.signal?.addEventListener("abort", () => {
			x.delete(s) && (d(f), o(/* @__PURE__ */ Error("aborted")));
		});
		try {
			p.send(l);
		} catch (e) {
			x.delete(s) && (d(f), o(e instanceof Error ? e : Error(String(e))));
		}
	});
	async function re(e) {
		if (f.getState().trackSubscription(e) && p?.readyState === U && _ === "open") {
			let t = f.getState().sessionState[e]?.lastAppliedSequence ?? 0;
			await M("subscribe", { sessionId: e }), await M("catch-up", {
				sessionId: e,
				sinceSequence: t
			});
		}
	}
	async function ie(e) {
		if (f.getState().untrackSubscription(e), p?.readyState === U && _ === "open") try {
			await M("unsubscribe", { sessionId: e });
		} catch (t) {
			console.warn("ws: unsubscribe ack failed", e, t);
		}
	}
	function N() {
		_ === "open" || _ === "connecting" || (b = !1, v = 0, j());
	}
	function ae() {
		p?.close();
	}
	function oe(e, t) {
		if (b = !0, D(), T(/* @__PURE__ */ Error("ws client closed")), p !== void 0) {
			try {
				p.close(e, t);
			} catch {}
			p = void 0;
		}
		C("closed");
	}
	function se(e) {
		return S.add(e), () => {
			S.delete(e);
		};
	}
	return {
		status: () => _,
		connect: N,
		close: oe,
		killWebSocket: ae,
		send: M,
		trackSession: re,
		untrackSession: ie,
		onEnvelope: se,
		url: t
	};
}
//#endregion
//#region src/ws/WsClientProvider.tsx
function ke(e, t) {
	return !!(e === "authenticated" || t && e === "unauthenticated");
}
var Ae = e(void 0);
function je(e) {
	let { auth: t, clientOptions: n, client: r, store: s, allowAnonymous: l = !1, children: u } = e, d = o(r), f = a(() => r === void 0 ? (d.current === void 0 && (d.current = W(n)), d.current) : r, [r]);
	return i(() => {
		if (ke(t.status, l)) return f.connect(), () => {
			f.close(), (s ?? n?.store)?.getState().reset();
		};
	}, [
		t.status,
		l,
		f,
		s,
		n
	]), /* @__PURE__ */ c(Ae.Provider, {
		value: f,
		children: u
	});
}
function Me() {
	let e = r(Ae);
	if (e === void 0) throw Error("useWsClient must be called inside <WsClientProvider>");
	return e;
}
//#endregion
//#region src/error-mapper/mapCreateSessionError.ts
function Ne(e, t) {
	return e === "validation-failed" ? "moderator.createSession.errors.validation" : e === "auth-required" || t === 401 ? "moderator.createSession.errors.unauthenticated" : t === 400 ? "moderator.createSession.errors.validation" : "moderator.createSession.errors.generic";
}
//#endregion
//#region src/error-mapper/mapGenericApiError.ts
function Pe(e, t, n) {
	return t === 401 ? "common.errors.unauthenticated" : t === 400 ? "common.errors.validation" : n;
}
//#endregion
//#region src/facet-pill/participant-color.ts
var G = Object.freeze([
	Object.freeze({
		bg: "bg-sky-100",
		text: "text-sky-900",
		ring: "ring-sky-300"
	}),
	Object.freeze({
		bg: "bg-amber-100",
		text: "text-amber-900",
		ring: "ring-amber-300"
	}),
	Object.freeze({
		bg: "bg-emerald-100",
		text: "text-emerald-900",
		ring: "ring-emerald-300"
	}),
	Object.freeze({
		bg: "bg-fuchsia-100",
		text: "text-fuchsia-900",
		ring: "ring-fuchsia-300"
	}),
	Object.freeze({
		bg: "bg-cyan-100",
		text: "text-cyan-900",
		ring: "ring-cyan-300"
	}),
	Object.freeze({
		bg: "bg-lime-100",
		text: "text-lime-900",
		ring: "ring-lime-300"
	})
]), Fe = G.length;
function K(e) {
	let t = 0;
	for (let n = 0; n < e.length; n++) {
		let r = e.charCodeAt(n), i;
		if (r >= 48 && r <= 57) i = r - 48;
		else if (r >= 97 && r <= 102) i = 10 + (r - 97);
		else if (r >= 65 && r <= 70) i = 10 + (r - 65);
		else continue;
		t = t + i >>> 0;
	}
	return G[t % G.length] ?? G[0];
}
//#endregion
//#region src/facet-pill/VoteIndicator.tsx
var Ie = {
	agree: "bg-emerald-500",
	dispute: "bg-rose-500"
};
function Le(e) {
	let { participantId: t, choice: n } = e, { t: r } = f(), i = K(t), a = Ie[n], o = r("methodology.voteIndicator.label", {
		participantId: t,
		choice: r(`methodology.voteIndicatorChoice.${n}`)
	});
	return /* @__PURE__ */ c("span", {
		"data-vote-indicator": "",
		"data-participant-id": t,
		"data-choice": n,
		role: "img",
		"aria-label": o,
		title: o,
		className: `inline-block h-2 w-2 rounded-full ring-1 ${i.ring} ${a}`
	});
}
var Re = t(Le), ze = Object.freeze([]), Be = "inline-flex items-center rounded-full border px-1.5 py-0.5 text-[10px] uppercase tracking-wide whitespace-nowrap", Ve = {
	proposed: "bg-white border-dashed border-slate-400 text-slate-500 opacity-60",
	agreed: "bg-slate-200 border-solid border-slate-700 text-slate-700 opacity-100",
	disputed: "bg-rose-100 border-solid border-rose-600 text-rose-700 ring-1 ring-rose-500 opacity-100",
	"meta-disagreement": "bg-violet-100 border-double border-violet-600 text-violet-700 ring-1 ring-violet-400 opacity-100",
	committed: "bg-slate-100 border-solid border-slate-400 text-slate-600 opacity-90",
	withdrawn: "bg-white border-dashed border-slate-400 text-slate-500 opacity-50",
	"awaiting-proposal": "bg-white border-dashed border-slate-400 text-slate-500 opacity-60"
};
function He(e) {
	let { facet: t, status: n, votes: r = ze } = e, { t: i } = f(), a = `${Be} ${Ve[n]}`, o = r.length > 0 ? /* @__PURE__ */ c("span", {
		"data-vote-indicator-row": "",
		className: "ml-1 inline-flex items-center gap-0.5",
		children: r.map((e) => /* @__PURE__ */ c(Re, {
			participantId: e.participantId,
			choice: e.choice
		}, e.participantId))
	}) : null;
	return /* @__PURE__ */ l("span", {
		"data-facet-pill": "",
		"data-facet-name": t,
		"data-facet-status": n,
		className: a,
		children: [i(`methodology.facet.${t}`), o]
	});
}
var Ue = t(He);
//#endregion
//#region src/facet-status/facet-status.ts
function q() {
	return {
		perParticipant: /* @__PURE__ */ new Map(),
		withdrawals: /* @__PURE__ */ new Set(),
		committed: !1,
		metaDisagreement: !1,
		hasCandidate: !1,
		candidateProposalEventId: null
	};
}
function We(e) {
	switch (e.kind) {
		case "capture-node": return {
			entityKind: "node",
			entityId: e.node_id,
			facet: "wording"
		};
		case "classify-node": return {
			entityKind: "node",
			entityId: e.node_id,
			facet: "classification"
		};
		case "set-node-substance": return {
			entityKind: "node",
			entityId: e.node_id,
			facet: "substance"
		};
		case "set-edge-substance": return {
			entityKind: "edge",
			entityId: e.edge_id,
			facet: "substance"
		};
		case "edit-wording": return {
			entityKind: "node",
			entityId: e.node_id,
			facet: "wording"
		};
		case "amend-node": return {
			entityKind: "node",
			entityId: e.node_id,
			facet: "wording"
		};
		case "decompose":
		case "interpretive-split":
		case "axiom-mark":
		case "meta-move":
		case "break-edge":
		case "annotate": return null;
		default: return null;
	}
}
function J(e, t, n, r, i) {
	let a = n === "node" ? e : t, o = a.get(r);
	o || (o = /* @__PURE__ */ new Map(), a.set(r, o));
	let s = o.get(i);
	return s || (s = q(), o.set(i, s)), s;
}
function Ge(e) {
	let t = /* @__PURE__ */ new Set(), n = !1, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
	for (let c = 0; c < e.length; c++) {
		let l = e[c];
		if (l.kind === "participant-joined") {
			if (l.payload.role === "moderator") continue;
			t.add(l.payload.user_id);
			continue;
		}
		if (l.kind === "participant-left") {
			t.delete(l.payload.user_id);
			continue;
		}
		if (l.kind === "node-created") {
			let e = J(i, a, "node", l.payload.node_id, "wording");
			e.hasCandidate = !0, J(i, a, "node", l.payload.node_id, "classification"), J(i, a, "node", l.payload.node_id, "substance");
			continue;
		}
		if (l.kind === "edge-created") {
			let e = J(i, a, "edge", l.payload.edge_id, "shape");
			e.hasCandidate = !0, J(i, a, "edge", l.payload.edge_id, "substance");
			continue;
		}
		if (l.kind === "withdraw-agreement") {
			J(i, a, l.payload.entity_kind, l.payload.entity_id, l.payload.facet).withdrawals.add(l.payload.participant);
			continue;
		}
		if (l.kind === "proposal") {
			let e = We(l.payload.proposal);
			if (e !== null) {
				let t = J(i, a, e.entityKind, e.entityId, e.facet);
				r.set(l.id, {
					...e,
					priorHasCandidate: t.hasCandidate
				}), t.hasCandidate = !0, t.candidateProposalEventId = l.id, t.perParticipant.clear();
			} else if (l.payload.proposal.kind === "meta-move") {
				let e = q();
				e.hasCandidate = !0, s.set(l.id, e);
			}
			continue;
		}
		if (l.kind === "vote") {
			if (l.payload.target === "facet") {
				if (l.payload.entity_kind === "annotation") {
					let e = o.get(l.payload.entity_id);
					e || (e = q(), e.hasCandidate = !0, o.set(l.payload.entity_id, e)), e.perParticipant.set(l.payload.participant, l.payload.choice);
					continue;
				}
				J(i, a, l.payload.entity_kind, l.payload.entity_id, l.payload.facet).perParticipant.set(l.payload.participant, l.payload.choice);
				continue;
			}
			let e = r.get(l.payload.proposal_id);
			if (!e) {
				let e = s.get(l.payload.proposal_id);
				e && e.perParticipant.set(l.payload.participant, l.payload.choice);
				continue;
			}
			J(i, a, e.entityKind, e.entityId, e.facet).perParticipant.set(l.payload.participant, l.payload.choice);
			continue;
		}
		if (l.kind === "commit") {
			if (l.payload.target === "facet") {
				let e = J(i, a, l.payload.entity_kind, l.payload.entity_id, l.payload.facet);
				e.committed = !0, l.payload.carried_from_edge_id !== void 0 && (e.hasCandidate = !0);
				continue;
			}
			let t = r.get(l.payload.proposal_id);
			if (!t) {
				let t = s.get(l.payload.proposal_id), n = c - 1;
				for (; n >= 0 && e[n].kind === "entity-included";) n--;
				let r = n >= 0 ? e[n] : void 0;
				if (t && r && r.kind === "annotation-created") {
					let e = r.payload.annotation_id, n = o.get(e);
					n || (n = q(), o.set(e, n));
					for (let [e, r] of t.perParticipant) n.perParticipant.set(e, r);
					n.hasCandidate = !0, n.committed = !0;
				}
				continue;
			}
			let n = J(i, a, t.entityKind, t.entityId, t.facet);
			n.committed = !0;
			continue;
		}
		if (l.kind === "meta-disagreement-marked") {
			if (l.payload.target === "facet") {
				let e = J(i, a, l.payload.entity_kind, l.payload.entity_id, l.payload.facet);
				e.metaDisagreement = !0;
				continue;
			}
			let e = r.get(l.payload.proposal_id);
			if (!e) continue;
			let t = J(i, a, e.entityKind, e.entityId, e.facet);
			t.metaDisagreement = !0;
			continue;
		}
		if (l.kind === "proposal-withdrawn") {
			let e = r.get(l.payload.proposal_id);
			if (!e) {
				s.delete(l.payload.proposal_id);
				continue;
			}
			let t = J(i, a, e.entityKind, e.entityId, e.facet);
			t.candidateProposalEventId === l.payload.proposal_id && (t.perParticipant.clear(), t.hasCandidate = e.priorHasCandidate, t.candidateProposalEventId = null);
			continue;
		}
		if (l.kind === "session-created") {
			n = l.payload.solo === !0;
			continue;
		}
	}
	let c = /* @__PURE__ */ new Map();
	for (let [e, r] of i) {
		let i = {};
		for (let [e, a] of r) i[e] = Y(a, t, n);
		c.set(e, i);
	}
	let l = /* @__PURE__ */ new Map();
	for (let [e, r] of a) {
		let i = {};
		for (let [e, a] of r) i[e] = Y(a, t, n);
		l.set(e, i);
	}
	let u = /* @__PURE__ */ new Map();
	for (let [e, r] of o) u.set(e, { substance: Y(r, t, n) });
	return {
		nodes: c,
		edges: l,
		annotations: u
	};
}
function Y(e, t, n) {
	if (e.metaDisagreement) return "meta-disagreement";
	if (!e.hasCandidate) return "awaiting-proposal";
	let r = [];
	for (let [n, i] of e.perParticipant) t.has(n) && r.push(i);
	let i = !1;
	for (let n of e.withdrawals) if (t.has(n)) {
		i = !0;
		break;
	}
	let a = r.some((e) => e === "dispute");
	if (e.committed && i) return "withdrawn";
	if (a) return "disputed";
	if (e.committed) return "committed";
	let o = t.size, s = r.filter((e) => e === "agree").length;
	if (o === 0) {
		if (n) return "agreed";
	} else if (s === o) return "agreed";
	return "proposed";
}
var Ke = Object.freeze({}), qe = [
	"proposed",
	"meta-disagreement",
	"disputed",
	"agreed",
	"committed",
	"withdrawn",
	"awaiting-proposal"
];
function Je(e) {
	let t = new Set(Object.values(e));
	for (let e of qe) if (t.has(e)) return e;
}
function Ye(e) {
	let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
	for (let [r, i] of e) {
		let e = r.indexOf(":");
		if (e < 0) continue;
		let a = r.lastIndexOf(":");
		if (a === e) continue;
		let o = r.slice(0, e), s = r.slice(e + 1, a), c = r.slice(a + 1), l = o === "node" ? t : o === "edge" ? n : null;
		if (l === null) continue;
		let u = l.get(s);
		u ? u[c] = i : l.set(s, { [c]: i });
	}
	return {
		nodes: t,
		edges: n,
		annotations: /* @__PURE__ */ new Map()
	};
}
//#endregion
//#region src/votes-by-facet/votes-by-facet.ts
var Xe = /* @__PURE__ */ new Map();
function Ze(e) {
	switch (e.kind) {
		case "classify-node": return {
			entityKind: "node",
			entityId: e.node_id,
			facet: "classification"
		};
		case "set-node-substance": return {
			entityKind: "node",
			entityId: e.node_id,
			facet: "substance"
		};
		case "set-edge-substance": return {
			entityKind: "edge",
			entityId: e.edge_id,
			facet: "substance"
		};
		case "edit-wording": return {
			entityKind: "node",
			entityId: e.node_id,
			facet: "wording"
		};
		default: return null;
	}
}
function Qe(e, t) {
	let n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
	for (let a of e) {
		if (a.kind === "proposal") {
			let e = Ze(a.payload.proposal);
			if (e === null) continue;
			n.set(a.id, e);
			continue;
		}
		if (a.kind === "vote") {
			let e = a.payload.participant;
			if (t !== null && e === t) continue;
			let o, s;
			if (a.payload.target === "facet") o = a.payload.entity_id, s = a.payload.facet;
			else {
				let e = n.get(a.payload.proposal_id);
				if (e === void 0) continue;
				o = e.entityId, s = e.facet;
			}
			let c = r.get(o);
			c === void 0 && (c = /* @__PURE__ */ new Map(), r.set(o, c));
			let l = c.get(s);
			l === void 0 && (l = [], c.set(s, l));
			let u = i.get(o);
			u === void 0 && (u = /* @__PURE__ */ new Map(), i.set(o, u));
			let d = u.get(s);
			d === void 0 && (d = /* @__PURE__ */ new Map(), u.set(s, d));
			let f = a.payload.choice, p = d.get(e);
			p === void 0 ? (d.set(e, l.length), l.push({
				participantId: e,
				choice: f
			})) : l[p] = {
				participantId: e,
				choice: f
			};
			continue;
		}
	}
	return r;
}
function $e(e) {
	return Qe(e, null);
}
function et(e, t) {
	return Qe(e, t);
}
//#endregion
//#region src/axiom-marks/axiom-marks.ts
var tt = Object.freeze([]);
function nt(e) {
	let t = /* @__PURE__ */ new Map(), n = [];
	for (let r of e) {
		if (r.kind === "proposal") {
			let e = r.payload.proposal;
			e.kind === "axiom-mark" && t.set(r.id, {
				nodeId: e.node_id,
				participantId: e.participant
			});
			continue;
		}
		if (r.kind === "commit") {
			if (r.payload.target !== "proposal") continue;
			let e = t.get(r.payload.proposal_id);
			if (e === void 0) continue;
			n.push({
				nodeId: e.nodeId,
				participantId: e.participantId,
				committedAt: r.payload.committed_at
			});
			continue;
		}
	}
	return n;
}
function rt(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let e = t.get(n.nodeId);
		e ? e.push(n) : t.set(n.nodeId, [n]);
	}
	return t;
}
//#endregion
//#region src/axiom-marks/AxiomMarkBadge.tsx
function it(e) {
	let { mark: t, screenName: n } = e, { t: r } = f(), i = K(t.participantId), a = n === void 0 ? r("methodology.axiomMark.tooltip", { participantId: t.participantId }) : r("methodology.axiomMarkBadge.tooltip", { screenName: n }), o = n === void 0 ? r("methodology.axiomMark.srLabel", { participantId: t.participantId }) : r("methodology.axiomMarkBadge.srLabel", { screenName: n });
	return /* @__PURE__ */ c("span", {
		"data-testid": `axiom-mark-badge-${t.nodeId}-${t.participantId}`,
		"data-participant-id": t.participantId,
		title: a,
		"aria-label": o,
		role: "img",
		className: `inline-flex h-5 w-5 items-center justify-center rounded-sm ${i.bg} ${i.text} ring-1 ${i.ring} text-[11px] font-semibold leading-none`,
		children: "A"
	});
}
var at = t(it), ot = class extends Error {
	name = "ReplayPositionError";
	position;
	headSequence;
	constructor(e, t) {
		super(`invalid replay position ${String(e)}; expected an integer in the inclusive range 0..${String(t)}`), this.position = e, this.headSequence = t;
	}
};
function X(e) {
	return e.length === 0 ? 0 : e[e.length - 1].sequence;
}
function st(e, t) {
	if (!Number.isInteger(e) || e < 0 || e > t) throw new ot(e, t);
}
function ct(e, t) {
	let n = X(e);
	return st(t, n), t < n ? t + 1 : n;
}
function lt(e, t) {
	return st(t, X(e)), t > 0 ? t - 1 : 0;
}
function ut(e) {
	return e === 0;
}
function dt(e, t) {
	return t === X(e);
}
function ft(e, t) {
	let n = X(t);
	return Number.isNaN(e) || e < 0 ? 0 : e > n ? n : Math.trunc(e);
}
//#endregion
//#region src/snapshot-list/SnapshotList.tsx
function pt(e) {
	let { status: t, snapshots: n, onSelect: r, onRetry: i } = e, { t: a } = f();
	return t === "loading" ? /* @__PURE__ */ c("div", {
		"data-testid": "snapshot-list-loading",
		role: "status",
		"aria-live": "polite",
		className: "px-3 py-2 text-sm italic text-slate-500",
		children: a("snapshotList.loading")
	}) : t === "error" ? /* @__PURE__ */ l("div", {
		"data-testid": "snapshot-list-error",
		role: "alert",
		className: "flex flex-col gap-2 px-3 py-2 text-sm text-slate-900",
		children: [/* @__PURE__ */ c("span", { children: a("snapshotList.error") }), /* @__PURE__ */ c("button", {
			type: "button",
			"data-testid": "snapshot-list-retry",
			onClick: () => i?.(),
			className: "self-start rounded border border-slate-300 bg-white px-2 py-1 text-xs font-medium text-slate-700 hover:bg-slate-50",
			children: a("snapshotList.retry")
		})]
	}) : n.length === 0 ? /* @__PURE__ */ c("div", {
		"data-testid": "snapshot-list-empty",
		role: "status",
		className: "px-3 py-2 text-sm italic text-slate-500",
		children: a("snapshotList.empty")
	}) : /* @__PURE__ */ c("nav", {
		"data-testid": "snapshot-list",
		"aria-label": a("snapshotList.regionAriaLabel"),
		className: "flex flex-col text-sm text-slate-900",
		children: /* @__PURE__ */ c("ol", {
			className: "flex flex-col",
			children: n.map((e) => /* @__PURE__ */ c("li", { children: /* @__PURE__ */ l("button", {
				type: "button",
				"data-testid": `snapshot-list-row-${e.snapshotId}`,
				"data-snapshot-id": e.snapshotId,
				"data-log-position": e.logPosition,
				"aria-label": a("snapshotList.rowAriaLabel", {
					label: e.label,
					position: e.logPosition
				}),
				onClick: () => {
					r(e.snapshotId);
				},
				className: "flex w-full items-baseline gap-2 border-b border-slate-100 px-3 py-2 text-left hover:bg-slate-50",
				children: [
					/* @__PURE__ */ c("span", {
						className: "truncate font-medium",
						children: e.label
					}),
					/* @__PURE__ */ l("span", {
						className: "shrink-0 text-xs text-slate-500",
						children: ["#", e.logPosition]
					}),
					/* @__PURE__ */ c("time", {
						dateTime: e.createdAt,
						"data-testid": `snapshot-list-row-${e.snapshotId}-created-at`,
						className: "ml-auto shrink-0 text-xs text-slate-400",
						children: e.createdAt
					})
				]
			}) }, e.snapshotId))
		})
	});
}
//#endregion
//#region src/snapshot-list/resolveSnapshotPosition.ts
function Z(e, t) {
	let n = e.find((e) => e.snapshotId === t);
	return n === void 0 ? null : n.logPosition;
}
//#endregion
//#region src/snapshot-list/useSessionSnapshots.ts
var mt = Object.freeze([]);
function ht(e) {
	if (typeof e != "object" || !e) return !1;
	let t = e;
	return !(typeof t.snapshotId != "string" || typeof t.label != "string" || typeof t.logPosition != "number" || typeof t.createdAt != "string");
}
function gt(e) {
	let [t, r] = s("loading"), [a, o] = s(mt), [c, l] = s(0);
	return i(() => {
		if (e === "") return;
		let t = !1;
		return r("loading"), o(mt), (async () => {
			try {
				let n = await fetch(`/api/sessions/${e}/snapshots`, {
					method: "GET",
					credentials: "include",
					headers: { Accept: "application/json" }
				});
				if (t) return;
				if (n.status !== 200) {
					r("error");
					return;
				}
				let i = await n.json();
				if (t) return;
				if (typeof i != "object" || !i || !Array.isArray(i.snapshots)) {
					r("error");
					return;
				}
				let a = i.snapshots, s = [];
				for (let e of a) {
					if (!ht(e)) {
						r("error");
						return;
					}
					s.push(e);
				}
				o(s), r("ready");
			} catch {
				t || r("error");
			}
		})(), () => {
			t = !0;
		};
	}, [e, c]), {
		status: t,
		snapshots: a,
		retry: n(() => {
			l((e) => e + 1);
		}, [])
	};
}
//#endregion
//#region src/snapshot-list/SnapshotJumpList.tsx
function _t(e) {
	let { sessionId: t, onJump: n } = e, { status: r, snapshots: i, retry: a } = gt(t);
	return /* @__PURE__ */ c(pt, {
		status: r,
		snapshots: i,
		onRetry: a,
		onSelect: (e) => {
			let t = Z(i, e);
			t !== null && n(t);
		}
	});
}
//#endregion
//#region src/snapshot-list/snapshot-navigation.ts
function Q(e) {
	return [...new Set(e.map((e) => e.logPosition))].sort((e, t) => e - t);
}
function vt(e, t) {
	for (let n of Q(e)) if (n > t) return n;
	return null;
}
function yt(e, t) {
	let n = Q(e);
	for (let e = n.length - 1; e >= 0; --e) if (n[e] < t) return n[e];
	return null;
}
//#endregion
//#region src/session-log/useSessionEventLog.ts
var bt = 100, xt = Object.freeze([]);
function St(e) {
	if (typeof e != "object" || !e) return !1;
	let t = e;
	return !(typeof t.id != "string" || typeof t.sequence != "number" || typeof t.kind != "string" || t.actor !== null && typeof t.actor != "string" || typeof t.createdAt != "string");
}
function Ct(e) {
	let [t, r] = s("loading"), [a, o] = s(xt), [c, l] = s(0);
	return i(() => {
		if (e === "") return;
		let t = !1;
		return r("loading"), o(xt), (async () => {
			try {
				let n = [], i = 0;
				for (;;) {
					let a = await fetch(`/api/sessions/${e}/events?after=${String(i)}&limit=${String(bt)}`, {
						method: "GET",
						credentials: "include",
						headers: { Accept: "application/json" }
					});
					if (t) return;
					if (a.status === 404) {
						r("not-found");
						return;
					}
					if (a.status !== 200) {
						r("error");
						return;
					}
					let o = await a.json();
					if (t) return;
					if (typeof o != "object" || !o || !Array.isArray(o.events)) {
						r("error");
						return;
					}
					let s = o;
					for (let e of s.events) St(e) && n.push(e);
					if (typeof s.nextCursor == "number") i = s.nextCursor;
					else break;
				}
				if (t) return;
				o(n), r("ready");
			} catch {
				t || r("error");
			}
		})(), () => {
			t = !0;
		};
	}, [e, c]), {
		status: t,
		events: a,
		retry: n(() => {
			l((e) => e + 1);
		}, [])
	};
}
//#endregion
//#region src/annotations/annotations.ts
var wt = Object.freeze([]);
function Tt(e) {
	let t = [];
	for (let n of e) n.kind === "annotation-created" && t.push({
		id: n.payload.annotation_id,
		kind: n.payload.kind,
		content: n.payload.content,
		targetNodeId: n.payload.target_node_id,
		targetEdgeId: n.payload.target_edge_id,
		createdBy: n.payload.created_by,
		createdAt: n.payload.created_at
	});
	return t;
}
function $(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		if (n.targetNodeId === null) continue;
		let e = t.get(n.targetNodeId);
		e ? e.push(n) : t.set(n.targetNodeId, [n]);
	}
	return t;
}
var Et = $;
function Dt(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		if (n.targetEdgeId === null) continue;
		let e = t.get(n.targetEdgeId);
		e ? e.push(n) : t.set(n.targetEdgeId, [n]);
	}
	return t;
}
//#endregion
//#region src/diagnostics/order-active-diagnostics.ts
function Ot(e) {
	let t = [...e.values()];
	return t.sort((e, t) => {
		if (e.severity !== t.severity) return e.severity === "blocking" ? -1 : 1;
		if (e.sequence !== t.sequence) return e.sequence - t.sequence;
		let n = I(e), r = I(t);
		return n < r ? -1 : +(n > r);
	}), t;
}
//#endregion
//#region src/supersession/supersession.ts
function kt(e) {
	let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set();
	for (let r of e) {
		if (r.kind === "proposal") {
			let e = r.payload.proposal;
			e.kind === "decompose" || e.kind === "interpretive-split" ? t.set(r.id, e.parent_node_id) : e.kind === "edit-wording" && e.edit_kind === "restructure" && t.set(r.id, e.node_id);
			continue;
		}
		if (r.kind === "proposal-withdrawn") {
			t.delete(r.payload.proposal_id);
			continue;
		}
		if (r.kind === "commit") {
			if (r.payload.target !== "proposal") continue;
			let e = t.get(r.payload.proposal_id);
			e !== void 0 && n.add(e);
		}
	}
	return n;
}
//#endregion
//#region src/index.ts
var At = "0.1.0";
//#endregion
export { Fe as AXIOM_MARK_PALETTE_SIZE, w as AuthProvider, te as AuthValueProvider, at as AxiomMarkBadge, wt as EMPTY_ANNOTATIONS, tt as EMPTY_AXIOM_MARKS, P as EMPTY_DIAGNOSTIC_HIGHLIGHTS, Ke as EMPTY_FACET_STATUSES, ze as EMPTY_VOTES, Xe as EMPTY_VOTES_BY_FACET_INDEX, Ue as FacetPill, ue as I18nProvider, se as LoginButton, Be as PILL_BASE_CLASSNAME, Ve as PILL_STATUS_CLASSNAME, qe as ROLLUP_PRIORITY, At as SHELL_PACKAGE_VERSION, N as SLOT_ROLES, ie as ScreenNameForm, _t as SnapshotJumpList, pt as SnapshotList, Re as VoteIndicator, je as WsClientProvider, V as WsRequestError, H as WsRequestTimeoutError, L as affectedEntities, K as axiomMarkColorFor, Ye as buildFacetStatusIndexFromBroadcast, Je as cardRollupStatus, ft as clampPosition, Ge as computeFacetStatuses, kt as computeSupersededNodeIds, B as createDefaultWsStore, z as createDefaultWsStoreInitializer, le as createI18nInstance, W as createWsClient, ae as deriveSlotOccupants, I as diagnosticIdentityKey, ge as diagnosticSeverityFor, he as edgeHasDiagnostic, ve as flattenActiveDiagnosticsForEdgeFire, _e as flattenActiveDiagnosticsForFire, Dt as groupAnnotationsByEdge, $ as groupAnnotationsByEntityId, Et as groupAnnotationsByNode, rt as groupAxiomMarksByNode, dt as isAtEnd, ut as isAtStart, ce as logout, Ne as mapCreateSessionError, Pe as mapGenericApiError, D as mapScreenNameError, oe as mergeSlots, ct as nextPosition, vt as nextSnapshotPosition, me as nodeHasDiagnostic, Ot as orderActiveDiagnostics, lt as prevPosition, yt as prevSnapshotPosition, Tt as projectAnnotations, nt as projectAxiomMarks, pe as projectDiagnosticHighlights, et as projectOtherVotesByFacet, $e as projectVotesByFacet, X as replayHeadSequence, Z as resolveSnapshotPosition, Q as snapshotPositions, T as useAuth, Ct as useSessionEventLog, gt as useSessionSnapshots, Me as useWsClient };

//# sourceMappingURL=index.js.map